import React, { useState } from 'react';
import SharedHelmet from "../Helmet";
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { BMI_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import BMITable from './BMITable';
const TITLE = 'Body Mass Index (BMI) Calculator for Adults - Easily Measure Your Health';
const DESCRIPTION = 'Is your weight appropriate for your height? Find out now using the Body Mass Index (BMI) calculator - use BMI to measure your fitness level and assess healthy weight.';
const KEYWORDS = 'Body Mass Index, BMI Calculator, Calculate BMI, How to Calculate BMI, BMI Formula, Health Indicators and BMI, Know My BMI, Healthy BMI, Analyzing BMI and Healthy Weight, How to Evaluate Your BMI, Measuring Body Mass Index, BMI Calculation for Men, BMI Calculation for Women';
const OG_URL = 'https://do-calculate.com/calculator/en/bmiadults/';
const apiEndpoint = `${SERVER_URL}/${BMI_EndPoint}`;
function BMICalculator() {
    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    };
    const calculateBMI = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ weight, height }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
                setClassification(data.result.classification);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '39px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                Is your weight appropriate for your height? Find out now using the Body Mass Index (BMI) calculator - use BMI to measure your fitness level and assess healthy weight. BMI is a measure used to determine the nutritional status of adults. It is calculated from a person's weight in kilograms, divided by their height (squared) in centimeters. The recommended levels are derived from the World Health Organization's recommendation, which indicates that the normal BMI range is between 18.5 and 24.9.<br />
                                This calculator returns the Body Mass Index (BMI) and its associated classification based on the levels set by the World Health Organization. The calculator calculates BMI for both men and women.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Body Mass Index (BMI) for Adults
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label htmlFor='height' className="form-label ms-2" >
                                        Height
                                    </label>
                                    </b>
                                    <input
                                        type="number"
                                        id="height"
                                        value={height}
                                        onChange={handleHeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                        placeholder="175"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">cm</span>
                                    </div>
                                </div> <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor='weightNumber' className="form-label ms-2">
                                        Weight
                                    </label>
                                    </b>
                                    <input
                                        type="number"
                                        id="weightNumber"
                                        value={weight}
                                        onChange={handleWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                        placeholder="65"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">kg</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                        calculateBMI} disabled={isLoading}>
                                        {isLoading ? (
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        ) : (
                                            'Calculate'
                                        )}
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <BMITable classification={classification}></BMITable>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                        <div className="row">
                            <div className="row">
                                <div className="col" >
                                    {statusCode === 400 && <div className="alert alert-warning"><b><u> Error Occurred:</u></b> Please enter valid height and weight </div>}
                                    {result && (
                                        <div>
                                            <h4>Results:</h4>
                                            <hr />
                                            <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                                <b> Body Mass Index (BMI):   </b>{result.BMI.toFixed(1)}  <label> kg/m²</label>
                                            </label>
                                            </div>
                                            <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                                <b> Classification:   </b> {result.classification}
                                            </label>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.healthCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <hr />
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                Calculate Body Mass Index (BMI) for Adults - Easily Measure Your Health
                            </div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Calculate Body Mass Index (BMI) for Adults - Easily Measure Your Health</h2></u>
                                <br />
                                <p>
                                    Body Mass Index (BMI), formerly known as the Quetelet Index, is a measure used to determine the nutritional status of adults. It is defined as a person's weight in kilograms divided by the square of their height in meters (kg/m²). For example, if an adult weighs 70 kg and is 1.75 meters tall, their BMI would be 22.9.
                                    70 (kg) / 1.752 (m²) = 22.9 BMI
                                    For adults over the age of 20, the measurement of BMI falls into one of the categories mentioned in the table above.
                                </p>
                                <p>
                                    BMI categories are based on the impact of excess fat in the body on diseases and mortality, and it is well-associated with fat management. BMI was developed as an indicator of the risk of developing diseases, as the risks increase with an increase in BMI. Some common conditions associated with excess weight and obesity include premature death, cardiovascular diseases, high blood pressure, joint dislocation, some types of cancer, and diabetes.
                                </p>
                                <p>
                                    BMI is also recommended for use in children and teenagers. In the case of children, BMI is calculated in the same way as for adults, and then it is compared to z-scores or percentiles. During childhood and adolescence, the ratio between weight and height varies by gender and age, so the reference values that determine the nutritional status of individuals aged 0 to 19 years depend on gender and age. The reference points for BMI for age for the year 2006 for children aged 0 to 5 years to diagnose overweight and obesity are percentiles 97 and 99, respectively. For individuals aged 5 to 19 years, overweight is defined as a BMI value above +1.
                                </p>
                                <hr />
                                <u><b>Date:</b></u> <br />
                                Body Mass Index (BMI) is very easy to measure and calculate, making it the most commonly used tool to link health problems' risks to weight at the population level. It was developed by Adolphe Quetelet in the nineteenth century. In the 1970s, based on data and the report of the Seven Countries Study, researchers noticed that BMI seemed to be a good indicator of fat management and weight problems. <br/>                                Like any other measurement, it is not perfect because it relies only on height and weight and does not take into account different levels of fat management based on age, levels of physical activity, and gender. For this reason, it is expected to exaggerate fat management in some cases and underestimate it in others. <br/>                                Other measurements such as waist circumference (WC) can complement BMI estimates. However, linking waist circumference to health risks is not straightforward and should be done scientifically using appropriate techniques. <br/>                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Benefits of Regular Physical Activity</h2></u>
                                <p>
                                    Regular physical activity, such as walking, cycling, and dancing, has significant health benefits. For example, it can reduce the risk of heart and artery diseases, diabetes, osteoporosis, help with weight control, and promote mental well-being.
                                </p>
                                <p>
                                    Participation in physical activity increases opportunities for social interaction and communication, enhancing cultural identity. Physical activity has a positive impact on both individuals and communities by promoting social interaction and cohesion.
                                </p>
                                <p>
                                    Especially among children and young people, sports and other physical activities empower self-esteem and increase self-confidence. In addition, physical activity helps prevent and control risky behaviors such as tobacco and alcohol use, unhealthy eating, and violence.
                                </p>
                                <p>
                                    Promoting physical activity also has a positive impact on the environment. For example, encouraging walking and cycling instead of motorized transport reduces traffic congestion, air and noise pollution, and fossil fuel consumption.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Benefits of a Balanced Diet</h2></u>
                                <ul>
                                    <li>
                                        Choosing a balanced and varied diet is an important step towards a happy and healthy lifestyle.
                                    </li>
                                    <li>
                                        Vitamins and minerals in the diet are essential for boosting immunity and healthy growth.
                                    </li>
                                    <li>
                                        A healthy diet can protect the human body from certain types of diseases, especially non-communicable diseases such as obesity, diabetes, heart diseases, and some types of cancer, and skeletal conditions.
                                    </li>
                                    <li>
                                        A healthy diet can also help maintain the appropriate body weight.
                                    </li>
                                    <li>
                                        Healthy nutrition is a good opportunity to enrich life by experiencing different foods from different cultures and sources, and in different ways of preparation.
                                    </li>
                                    <li>
                                        The benefits of consuming a variety of foods also include emotional aspects, as diversity and color are important elements of a balanced diet.
                                    </li>
                                </ul>
                                <br/>                                <b>Source:</b>
                                <a href="https://www.who.int/europe/news-room/fact-sheets/item/a-healthy-lifestyle---who-recommendations">
                                    World Health Organization
                                </a>
                                <br />
                                <b>Last Review Date:</b>
                                31/05/2023
                            </div>
                        </div>
                    </div>
                    <hr />
                    <br />
                    <u>
                        <h2>Frequently Asked Questions</h2>
                    </u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What is Body Mass Index (BMI)?</h3>
                            </div>
                            <div className="info-section-body">
                                Body Mass Index (BMI) is one of the common methods to determine whether your weight is healthy or not. It is used to measure the body fat percentage based on weight and height for adults.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How is Body Mass Index (BMI) calculated?</h3>
                            </div>
                            <div className="info-section-body">
                                Body Mass Index (BMI) is calculated by dividing a person's weight (in kilograms) by the square of their height (in meters). American units (pounds and inches) can also be used when converting from standard units. Once you have this number, you can multiply it by 703 to get the final BMI percentage.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What are the Body Mass Index (BMI) categories?</h3>
                            </div>
                            <div className="info-section-body">
                                Once you calculate your Body Mass Index (BMI), you will find yourself in one of the following categories:
                                <ul>
                                    <li>Less than 18.5: Underweight range</li>
                                    <li>18.5 to 24.9: Healthy weight range</li>
                                    <li>25.0 to 29.9: Overweight range</li>
                                    <li>30.0 and above: Obesity range</li>
                                </ul>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Can Body Mass Index (BMI) tell me how much weight I should lose?</h3>
                            </div>
                            <div className="info-section-body">
                                The index itself will not provide you with a weight loss goal, but you can use BMI tables available on the National Institutes of Health (NIH) website to calculate how much you should lose to achieve a healthy/normal BMI range.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What is the average Body Mass Index (BMI)?</h3>
                            </div>
                            <div className="info-section-body">
                                According to the 2018 National Health Statistics Report from the Centers for Disease Control and Prevention (CDC), the average Body Mass Index (BMI) for American women over the age of 20 is 29.6, and it is 29.1 for American men in the same age group.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Does Body Mass Index (BMI) differ between men and women?</h3>
                            </div>
                            <div className="info-section-body">
                                Although the Centers for Disease Control and Prevention (CDC) reports population data by gender, Body Mass Index (BMI) does not differentiate between men and women. The same method and categories are used regardless of gender.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How accurate is Body Mass Index (BMI)?</h3>
                            </div>
                            <div className="info-section-body">
                                While Body Mass Index (BMI) is a reliable indicator of weight conditions, it is not perfect. The index is designed to measure body fat percentage and does not take factors such as muscle mass or bone density into account.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Is knowing Body Mass Index (BMI) important for weight loss?</h3>
                            </div>
                            <div className="info-section-body">
                                It's a useful piece of information to have, but it's not the only critical piece of information available to you when it comes to weight loss. As discussed earlier, Body Mass Index (BMI) only estimates body fat percentage and does not consider muscle mass, water weight, or bone density. Precisely determining these components is essential for building a successful weight loss program.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Does Body Mass Index (BMI) differ between men and women?</h3>
                            </div>
                            <div className="info-section-body">
                                Although the Centers for Disease Control and Prevention (CDC) reports population data by gender, Body Mass Index (BMI) does not differentiate between men and women. The same method and categories are used regardless of gender.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default BMICalculator;
